export default __webpack_public_path__ + "static/bonners-bf5af005bef34e030db1b0c4b797bf72.jpg";